import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import style from './GridRow.module.scss.js';

var _excluded = ["noGutters", "className"];
var GridRow = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var noGutters = _ref.noGutters,
    className = _ref.className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var DEVICE_SIZES = ['xl', 'lg', 'md', 'sm', 'xs'];
  var sizePrefix = 'row-cols';
  var classes = [];
  DEVICE_SIZES.forEach(function (breakpoint) {
    var propValue = props[breakpoint];
    delete props[breakpoint];
    var cols;
    if (propValue != null && typeof propValue === 'object') {
      cols = propValue.cols;
    } else {
      cols = propValue;
    }
    var infix = breakpoint !== 'xs' ? "-" + breakpoint : '';
    if (cols != null) classes.push(style["" + sizePrefix + infix + "-" + cols]);
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, props, {
    className: cx.apply(void 0, [noGutters && style['no-gutters'], style.row, className].concat(classes))
  }));
});
var rowColWidth = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
var rowColumns = PropTypes.oneOfType([rowColWidth, PropTypes.shape({
  cols: rowColWidth
})]);
var GridRowPropTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** Removes the gutter spacing between Cols as well as any added negative margins. */
  noGutters: PropTypes.bool,
  xs: rowColumns,
  sm: rowColumns,
  md: rowColumns,
  lg: rowColumns,
  xl: rowColumns
};
GridRow.propTypes = GridRowPropTypes;
GridRow.defaultProps = {
  noGutters: false
};
GridRow.displayName = 'GridRow';

export { GridRowPropTypes, GridRow as default };
//# sourceMappingURL=GridRow.js.map
